<script setup>
import TeamDetailModal from "@/components/modal/team-detail-modal.vue";
import {defineProps, ref, watch, computed} from "vue";
import {useQuery} from "@vue/apollo-composable";
import {GET_TEAM_BY_TOURNAMENT} from "@/graphql/operations/team.ts";

// Props
const props = defineProps({
  tournament: {
    type: Object,
    default: null,
  },
});

// State
const keyword = ref("");
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true,
});

const initialData = ref(null);
const showModal = ref(false);

const totalPages = computed(() =>
    Math.ceil(pagination.value.total / pagination.value.pageSize)
);

// Query
const {result, refetch} = useQuery(
    GET_TEAM_BY_TOURNAMENT,
    () => ({
      documentId: props.tournament?.documentId ?? '',
      keyword: keyword.value,
      page: parseInt(pagination.value.current),
      pageSize: parseInt(pagination.value.pageSize),
    }),
    {
      fetchPolicy: "no-cache",
    }
);

// Data handling
const teamPlayers = computed(() => result.value?.teams_connection?.nodes || []);

watch(result, () => {
  const pageInfo = result.value?.teams_connection?.pageInfo;
  if (pageInfo) {
    pagination.value.total = pageInfo.total || 0;
    pagination.value.current = pageInfo.page || 1;
  }
});

// Pagination Controls
const handleTableChange = () => {
  pagination.value.current = 1;
};

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    pagination.value.current = page;
  }
};

// Keyword Search Handler
const searchKeyword = () => {
  handleTableChange();
};

const openModal = (record) => {
  showModal.value = true;
  initialData.value = record;
}

// Watch prop change
watch(
    () => props.tournament,
    (newTournament) => {
      if (newTournament) {
        refetch({
          documentId: props.tournament?.documentId ?? '',
          keyword: keyword.value,
          page: parseInt(pagination.value.current),
          pageSize: parseInt(pagination.value.pageSize),
        });
      }
    }
);
</script>

<template>
  <div class="coache-head-blk mb-3">
    <div class="d-flex justify-content-end align-items-center">
      <div class="w-100">
        <div class="d-flex w-100 justify-content-start gap-4">
          <div id="tablefilter">
            <div class="dataTables_filter d-flex gap-1">
              <label>
                <input v-model="keyword" class="form-control form-control-sm" placeholder="Tìm kiếm"
                       style="min-width: unset" type="search">
              </label>
            </div>
          </div>
          <div class="request-coach-list">
            <div class="card-header-btns">
              <nav>
                <div class="nav nav-tabs" role="tablist">
                  <button class="nav-link active text-nowrap" type="button" @click="searchKeyword">
                    Tìm kiếm
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive table-datatble">
    <table class="table table-borderless dashboard-card-table">
      <colgroup>
        <col width="x"/>
        <col width="15%"/>
      </colgroup>
      <thead class="thead-light">
      <tr>
        <th>Tên đội</th>
        <th>Số vận động viên</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in teamPlayers" :key="item.id" :data-key="index" class="text-start">
        <td style="padding-left: unset">
          <h5 style="cursor: pointer" @click="openModal(item)"> {{ item?.name }}</h5>
        </td>
        <td style="padding-right: unset">
          {{ item?.players?.length ?? 0 }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="tab-footer">
    <div class="row">
      <div class="col-md-6">
        <div id="tablelength">
          <div class="dataTables_length">
            <label>Hiển thị
              <select
                  v-model="pagination.pageSize"
                  class="custom-select custom-select-sm form-control form-control-sm"
                  @change="handleTableChange"
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="999999">All</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div id="tablepage">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                  :class="{ disabled: pagination.current === 1 }"
                  class="paginate_button page-item previous"
                  @click="changePage(pagination.current - 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-left"></i>
                </a>
              </li>

              <li
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: pagination.current === page }"
                  class="paginate_button page-item"
                  @click="changePage(page)"
              >
                <a class="page-link" href="javascript:void(0);">{{ page }}</a>
              </li>

              <li
                  :class="{ disabled: pagination.current === totalPages }"
                  class="paginate_button page-item next"
                  @click="changePage(pagination.current + 1)"
              >
                <a class="page-link" href="javascript:void(0);">
                  <i class="feather-chevrons-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <TeamDetailModal v-model:visible="showModal" :initial-data="initialData"
                   :style="{ width: '50%', minWidth: '600px' }"></TeamDetailModal>
</template>

<style scoped>

</style>